import { connect } from 'Modules/core/redux';


import { i18nActions } from '../../state/actions';
import { LanguageSelector } from '../LanguageSelector';


export const ConnectedLanguageSelector = connect(
    null,
    {
        languageChanged: i18nActions.languageChanged,
    },
)(LanguageSelector);
